import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class LocBillingCodeRatesBus extends BaseBus
{
    constructor(data: LocBillingCodeRatesBus) {
        super(data);
    }

    CID(): any {
        return this.locBillingCodeRateId;
    }
    setId(id: any) {
        this.locBillingCodeRateId = id;
    }
    initialize(data: LocBillingCodeRatesBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: LocBillingCodeRatesBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    locBillingCodeRateId: string;
    billingCodeId: string;
    billingCode: string;
    customerId: string;
    locationId: string;
    rate: number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    accountClassId: string;
    createdDt : string;
    createdUser : string;
    locationName : string;
    count: number;
}
